var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { CALL_TRACKING_PATH } from "@/constants/api";
import { useBrandUrl } from "@/hooks";
import { fetchWithTimeout, getFeaturesEnabled } from "@/utils";
import { createContext, useCallback, useMemo, useState } from "react";
import { CallTrackingStatus } from "./types";
import { useCallTrackingRequest } from "./hooks";
export const CallTrackingContext = createContext(null);
export const CallTrackingProvider = ({ children }) => {
    const { callTracking } = getFeaturesEnabled();
    const callTrackingUrl = useBrandUrl({ endpoint: CALL_TRACKING_PATH });
    const options = useCallTrackingRequest();
    const [status, setStatus] = useState(callTracking ? CallTrackingStatus.IDLE : CallTrackingStatus.DISABLED);
    const [numberMappings, setNumberMappings] = useState([]); // this state makes no sense and should be removed later
    const [virtualPhoneNumbers, setVirtualPhoneNumbers] = useState([]);
    const fetchCallTrackingData = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        if (!callTrackingUrl) {
            console.warn("fetchCallTrackingData: URL is empty.");
            setStatus(CallTrackingStatus.ERROR);
            return;
        }
        setStatus(CallTrackingStatus.LOADING);
        try {
            const response = yield fetchWithTimeout(callTrackingUrl, options, 3000);
            if (!response.ok) {
                console.error(`fetchCallTrackingData: Failed to fetch, status: ${response.status}`);
                setStatus(CallTrackingStatus.ERROR);
                return;
            }
            const json = yield response.json();
            const data = json === null || json === void 0 ? void 0 : json.data;
            setNumberMappings((_a = data.numberMappings) !== null && _a !== void 0 ? _a : []);
            setVirtualPhoneNumbers((_c = (_b = data.numberMappings) === null || _b === void 0 ? void 0 : _b.map((mapping) => mapping.virtualPhoneNumber)) !== null && _c !== void 0 ? _c : []);
            setStatus(CallTrackingStatus.SUCCESS);
        }
        catch (error) {
            setStatus(CallTrackingStatus.ERROR);
        }
    }), [callTrackingUrl, options]);
    const contextValue = useMemo(() => ({
        numberMappings,
        fetchCallTrackingData,
        status,
        virtualPhoneNumbers,
        // preserve original API so existing code does not break but should be removed
        isCallTrackingRequestDone: status === CallTrackingStatus.SUCCESS ||
            status === CallTrackingStatus.ERROR,
    }), [numberMappings, fetchCallTrackingData, status, virtualPhoneNumbers]);
    return (_jsx(CallTrackingContext.Provider, { value: contextValue, children: children }));
};
